<div [formGroup]="parentFormGroup">
  <ng-select [formControlName]="passFormControlName" [addTag]="addTagFn" [multiple]="true"> </ng-select>
</div>
